import { createContext, useContext } from "react";

export const NotificationMachineContext = createContext([] as any);
export const useNotificationMachineValue = () =>
  useContext(NotificationMachineContext);
